/* eslint-disable no-magic-numbers */
const { hash } = require('imghash');

const SimilaridadeUtil = {
    /**
     * Converte um hash hexadecimal para sua representação binária (0s e 1s).
     * 
     * @param {string} hexHash - O hash em formato hexadecimal.
     * @returns {string} O hash em formato binário.
     * @example
     * hexToBinary('ff0000ffc1e300ff') => '1111111100000000000000001111111111000001111000110000000011111111'
     */
    hexToBinary: (hexHash) => {
        return hexHash
            .split('')
            .map(char => parseInt(char, 16).toString(2).padStart(4, '0'))
            .join('');
    },

    /**
     * Gera o Perceptual Hash de uma imagem para detecção de duplicatas e fraudes.
     * 
     * @param {Buffer | string} imageContent - O conteúdo da imagem (Buffer) ou o caminho do arquivo (string).
     * @param {number} [bits=64] - Resolução do hash. O padrão é 64 (gera um hash de 64-bits / 16 caracteres Hex).
     * @returns {Promise<string>} O hash perceptual em formato Hexadecimal.
     */
    generateImagePHash: async (imageContent, bits = 64) => {
        try {
            // A biblioteca converte a imagem para tons de cinza, redimensiona 
            // para uma matriz 64x64 (se bits=64) e calcula o gradiente visual.
            const perceptualHash = await hash(imageContent, bits);
            
            return SimilaridadeUtil.hexToBinary(perceptualHash);
        } catch (error) {
            // Trata erros comuns, como formatos de imagem não suportados ou corrompidos
            const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido';
            throw new Error(`Falha ao analisar o conteúdo da imagem para hashing: ${errorMessage}`);
        }
    },

    /**
     * Verifica a similaridade de uma imagem com base no hash perceptual armazenado no banco de dados.
     * @param {*} knex 
     * @param {*} hash - O hash em formato hexadecimal.
     * @param {number} [bits=64] - Resolução do hash em bits. O padrão é 64 (gera um hash de 64-bits / 16 caracteres Hex).
     * @returns O objeto contendo informações da imagem correspondente, ou null se não houver correspondência.
     */
    verificarSimilaridade: async (knex, hash, bits = 64) => {
        const expectedLength = bits / 4; // Cada caractere hex representa 4 bits
        const hexRegex = new RegExp(`^[0-9a-fA-F]{${expectedLength}}$`);
        
        if (!hexRegex.test(hash)) {
            throw new Error(`O hash fornecido é inválido. Esperado um hexadecimal de ${expectedLength} caracteres para ${bits} bits.`);
        }
        try {
            // TODO: No futuro, quando atualizarmos o PostgreSQL para a versão 14+, poderemos usar funções de bit_count para tratar tresholds de similaridade, 
            // permitindo encontrar imagens com hashes semelhantes, não apenas idênticos.
            const resultado = await knex('stt.imagem_dicom')
            .select('*')
            .whereRaw(`visual_hash = x'${hash}'::bit(${bits})`)
            .first();

            return resultado;

        } catch (error) {
            console.error('Erro na query de busca:', error);
            throw error;
        }
    }

};

module.exports = SimilaridadeUtil;
